// extracted by mini-css-extract-plugin
export default {"title":"WithdrawSuccessSend_title__V6-Df","description":"WithdrawSuccessSend_description__QQY-k"};